import { connect } from 'react-redux';
import * as metaSelectors from 'redux-modules/meta/selectors.js';
import * as uiStateSelectors from 'redux-modules/uiState/selectors.js';
import Form from './Form';

function mapStateToProps(state) {
  return {
    language: uiStateSelectors.selectResumeLanguage(state),
    languageMeta: metaSelectors.selectMeta(state),
    supportedLanguages: uiStateSelectors.selectAppLanguageCodes(state)
  };
}

export default connect(mapStateToProps, null)(Form);
